var styles = {"Link":"_85e08dU05-w-","icon":"CXh2JiLW-bA-"};

export { styles as default };
//# sourceMappingURL=Link.module.css.js.map
